// Assemblage bookkeeping (docs/02-Game-Design/Assemblage Mode.md): the goal
// is every star in a constellation. A blocked star is unused, and a star in
// the word in progress is not yet used either: only submitted words count.
import type { PlayLevel } from '../level/schema';
import type { PlayState } from '../play/types';

/** How many stars the level has. Assemblage levels hold stars only. */
export function starsTotal(level: PlayLevel): number {
  return level.nodes.filter((n) => n.type === 'star').length;
}

/** How many stars are in submitted constellations. */
export function starsUsed(state: PlayState): number {
  const stars = new Set(state.level.nodes.filter((n) => n.type === 'star').map((n) => n.id));
  let used = 0;
  for (const c of state.constellations) for (const id of c.nodes) if (stars.has(id)) used++;
  return used;
}

/** Complete: every star is in a submitted constellation. */
export function assemblageComplete(state: PlayState): boolean {
  return starsUsed(state) === starsTotal(state.level);
}
